import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import { layoutSpacing } from '../../Tokens/Scales';

const AppContainer = React.forwardRef(({
  children,
  maxWidth = 'xl',
  disableGutters = false,
  sx,
  ...props
}, ref) => (
  <Container
    ref={ref}
    maxWidth={maxWidth}
    disableGutters={disableGutters}
    sx={{
      px: disableGutters ? 0 : `${layoutSpacing.pagePadding}px`,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Container>
));

AppContainer.displayName = 'AppContainer';

AppContainer.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    PropTypes.bool,
  ]),
  disableGutters: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AppContainer;
